import type { Game } from '../shared/types';
import { islandPlace, ISLAND_COVER_ROOT } from './island-world';
export function atlasCover(game: Pick<Game, 'slug' | 'coverImage'>) {
  const place = islandPlace(game.slug);
  return place ? `${ISLAND_COVER_ROOT}/${place.slug}.webp` : game.coverImage;
}
